module.exports = __webpack_public_path__ + "static/media/live_sessions_logo.2d497dcf.png";